/* eslint-disable no-undef */
import pubsub from 'pubsub-js';
import loadingModal from './loading-modal';
import gaTracker from './ga-tracker';
import customTracker from './custom-tracker';
import Cookie from 'js-cookie';
import { datadogLogs } from "@datadog/browser-logs";
datadogLogs.logger.info("The v2 theme file ran: /src/js/shopping-cart.js", {type: 'file accessed', filename: "/src/js/shopping-cart.js"});


var url = window.location.origin + '/wp-admin/admin-ajax.php?x=' + Math.round(Math.random()*999999);

function init() {
	
	var $addToCart = $('.js-add-to-cart'),
		$cartCount = $('.js-cart-count'),
		$product = $('.js-product');
	
	$addToCart.on('click.add_item', function(event) {
		event.preventDefault();
		pubsub.publish('cart.add_item', {
			type: $product.data('product-type'),
			quantity: $('.js-product-qty').val(),
			price: $product.data('product-price'),
			id: $product.data('product-id')
		});
	});
	
	

	if (Cookie.get("woocommerce_cart_quantity")) {
		var itemsInCart = Cookie.get('woocommerce_cart_quantity');
		itemsInCart="/wp-content/themes/mintmobile/images/Cart"+itemsInCart+".png";
		$cartCount.attr("src",itemsInCart);
	}
	
}


function addProduct(e, data) {
	var type = data.type,
		quantity = data.quantity,
		price = data.price,
		id = data.id;

	// Purposely using coercion here.
	if (quantity == 0) {
		return;
	}

	loadingModal.show('Adding ' + type + ' to cart...');

	$.ajax({
		type: 'post',
		url: url,
		data: {
			action: 'add_item_to_cart',
			product_id: id,
			quantity: quantity
		},
		success: function(response) {
			
			if (data.tracker) {
				gaTracker.trackEcomm(data.tracker);
			}
			
			customTracker();
			
			window.location = window.location.origin + '/cart';
		},
		fail: function(response) {
			console.log(response);
		}
	});

}

function removeProduct(event, element) {

	var $product = $(element).closest('.js-cart-product'),
		productId = $product.data('product-id');
	
	$.ajax({
		type: 'post',
		url: url,
		data: {
			action: 'remove_item_from_cart',
			'product_id': productId
		},
		success: function (response) {
			if (response) {
				window.location.reload();
			}
		}
	});

}

export default {
	init,
	addProduct,
	removeProduct
}